import {
    SET_OBS_DOWN_PAYMENT,
    SET_OBS_TERM,
    SET_OBS_CREDIT,
    SET_SHOW_OBS,
    SET_OBS,
} from './constants';

const defaultState = {
    obsDownPayment: 0,
    obsTerm: 84,
    obsCredit: 1,
    showOBS: false,
};

const obs = (state = defaultState, action) => {
    switch (action.type) {
        case SET_OBS:
            return {
                obsDownPayment: action.obs.downPayment,
                obsTerm: action.obs.length,
                obsCredit: action.obs.obsType,
                showOBS: action.obs.showObs,
            };

        case SET_OBS_DOWN_PAYMENT:
            return { ...state, obsDownPayment: action.obsDownPayment };

        case SET_OBS_TERM:
            return { ...state, obsTerm: action.obsTerm };

        case SET_OBS_CREDIT:
            return { ...state, obsCredit: action.obsCredit };

        case SET_SHOW_OBS:
            return { ...state, showOBS: action.showOBS };


        default:
            return state;
    }
};

export default obs;



// WEBPACK FOOTER //
// ./src/containers/common/obs/reducer.js